// IE 2026 09 28 / ODOO-342342 (Igor: «добавь в элемент-инструкции поиск как в форме-меню»; уточнение: «"меню" — должно быть прижато вправо
// и использовать форму меню как на скрин2» — форма MenuPanel, как ≡ таблицы): МЕНЮ ЧИТАЛКИ ДОКУМЕНТАЦИИ — логика без Vue.
//
// Форма (AttrMD → MenuPanel справа в шапке читалки; кнопка «Contents» открывает её же) — группы:
//   * Contents — разделы открытого документа (## / ### его текста, якоря — как у AttrMD: {#id} или слаг заголовка); выбор — переход к
//     разделу на месте без запроса бэка (docsNav_jump), Back возвращает;
//   * «Все инструкции» (заголовок — H1 оглавления руководства на языке интерфейса, ссылка на него) — страницы руководства по группам
//     оглавления: индекс бэка (widget_DOCS.docs_index); бэк без метода — одна строка «All guides» у документов руководства;
//   * Command panel — команды читалки (Back и команды вида), кроме «Contents» (она открывает эту форму);
//   * Found in text — при введённом запросе: совпадения в тексте страниц руководства (индекс бэка: страница → разделы с простым текстом),
//     страница › раздел, фрагмент с подсветкой; выбор — страница на этом разделе на месте (docsNav_open), Back возвращает.
// Поиск — поле MenuPanel: фильтрует все группы сразу (его лестница: фраза → части → раскладка → опечатки) и передаёт запросы сюда
// (docsSearch_find — та же лестница searchMatch.searchLadder по строкам [заголовок раздела, текст раздела], опечатки до ступени 3).
// Языки (ODOO-341407): индекс — на языке интерфейса; ничего не нашлось — индекс en (запасной), группа с нейтральной пометкой «Matches in
// other languages»; индекс на русском пользователю uk / en бэк не отдаёт.
// Индекс кэшируется на сеанс: база · версия бэка · язык. Выключатель — fe.help.docsSearch (utils/docsNav.js); замеры — docsSearch_stats()
// (window.helpDocs.search()). Модуль без Vue и без стора (они приходят параметрами) — юнит-тест tests/unit/docsSearch.test.mjs.
import { searchLadder, highlightRanges } from './searchMatch'
import { docsNav_norm, docsNav_path, docsNav_inGuide, docsNav_contentsLink, CONTENTS_LINK, docsNav_backendHas, docsNav_backendDeclared } from './docsNav'   // IE 2026 09 28 / ODOO-342342: + docsNav_backendHas, docsNav_backendDeclared

export const DOCS_CMD = 'open_doc'          // команда пунктов-документов меню (подсказка Alt: Command); выполняет AttrMD.docsMenuPick
export const TEXT_MAX_TIER = 3              // опечатки в тексте — до «двух букв» (4 и 6 на длинных текстах дают ложные совпадения)
export const MAX_PAGES = 8, MAX_SECTIONS = 4 // найденное в тексте: страниц в группе, разделов у страницы (остальные — строкой «ещё N»)
export const SNIPPET_BEFORE = 40, SNIPPET_AFTER = 110
const RETRY_MS = 60000                       // ошибка запроса индекса — повтор не раньше

const cache = {}   // `${dbid}|${version_backend}|${lang}` → { state: loading | ready | unsupported | error, index, at, ms, bytes, waiters }
// IE 2026 09 28 / ODOO-342342: базы, где бэк ответил «метода нет» (unsupported), — до перезагрузки страницы docs_index больше не зовём ни
// на каком языке и версии (Demo: 43 «!!ERROR method=docs_index» — запрос на каждый язык интерфейса и запасной en). Ревью п.6: только в
// старом режиме — бэк НЕ объявил docs_index (выключатель fe.help.docsIndexCapability = false); у объявившего бэка ответ без индекса — ошибка
const unsupportedDb = new Set()
// IE 2026 09 28 / ODOO-342342: + unsupportedSkipped (мемо по базе), noCapability (запрос не ушёл — бэк не объявил docs_index), declaredEmpty
// (бэк объявил docs_index, а ответ без индекса — сессия истекла и т. п.: ошибка с повтором через RETRY_MS, ревью п.6)
const stats = { indexRequests: 0, indexReady: 0, indexMs: 0, indexBytes: 0, unsupported: 0, unsupportedSkipped: 0, noCapability: 0, declaredEmpty: 0, roSkipped: 0, errors: 0, searches: 0, searchMs: 0, searchMaxMs: 0, fallbackEn: 0, picks: 0, opens: 0 }   // IE 2026 09 29 / ODOO-342781 (ревью F1): + roSkipped — запрос не ушёл: роль «только чтение», политика бэка метод не разрешает
const now = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now())
const round = (x) => Math.round(x * 10) / 10

// ---------------------------------------------------------------- Contents: разделы открытого документа

const FENCE_RE = /^\s*(```|~~~)/
const HEADING_RE = /^(#{1,6})[ \t]+(.*?)[ \t]*$/
const ANCHOR_RE = /\s*\{#([^}\s]+)\}\s*$/
// якорь заголовка — ровно как AttrMD (heading_anchors): явный {#id}, иначе слаг inline-текста заголовка
export function docsSearch_anchor(raw) {
    const s = String(raw ?? '')
    const m = s.match(ANCHOR_RE)
    if (m) return m[1]
    return s.trim().toLowerCase().replace(/[^a-z0-9Ѐ-ӿ]+/g, '-').replace(/^-+|-+$/g, '')
}
// текст заголовка для пункта меню: без {#id}, разметки ссылок, `код`, **жирного**
export function docsSearch_plainHeading(raw) {
    return String(raw ?? '').replace(ANCHOR_RE, '').replace(/!?\[([^\]]*)\]\([^)]*\)/g, '$1').replace(/\*\*|__|`|\*/g, '').replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim()
}
// заголовки ## и ### текста документа вне блоков кода: [{ level, text, anchor }] (# — заголовок документа — не раздел)
export function docsSearch_headings(md) {
    const out = []
    let fence = false
    for (const ln of String(md ?? '').split('\n')) {
        if (FENCE_RE.test(ln)) { fence = !fence; continue }
        if (fence) continue
        const m = ln.match(HEADING_RE)
        if (!m || m[1].length < 2 || m[1].length > 3) continue
        const raw = m[2].replace(/[ \t]+#+[ \t]*$/, '')
        const text = docsSearch_plainHeading(raw)
        if (text) out.push({ level: m[1].length, text, anchor: docsSearch_anchor(raw) })
    }
    return out
}

// ---------------------------------------------------------------- индекс бэка (widget_DOCS.docs_index)

function cacheKey(store, lang) {
    return `${store?.user?.database?.dbid || ''}|${store?.version_backend || ''}|${lang || ''}`
}
const dbKey = (store) => String(store?.user?.database?.dbid || '')   // IE 2026 09 28 / ODOO-342342
export function docsSearch_cached(store, lang) {
    const e = cache[cacheKey(store, lang)]
    return e && e.state === 'ready' ? e.index : null
}
export function docsSearch_state(store, lang) {
    const st = (cache[cacheKey(store, lang)] || {}).state || ''
    return st === 'ready' || !unsupportedDb.has(dbKey(store)) ? st : 'unsupported'   // IE 2026 09 28 / ODOO-342342
}
// вердикт ответа docs_index: ready — индекс; unsupported — пустой ответ без ошибки (бэк без метода: views.executeWidgetMethod на незнакомый
// метод отвечает пустым ответом); error — нет ответа, уведомление error / critical
export function docsSearch_verdict(answer) {
    if (!answer || typeof answer !== 'object') return 'error'
    if (answer.isAuthenticated === false) return 'error'   // IE 2026 09 28 / ODOO-342342 (ревью п.6): сессия истекла — не «метода нет»
    const status = answer.notification?.status
    if (status === 'error' || status === 'critical' || answer.error) return 'error'
    const idx = answer.docs_index
    if (idx && typeof idx === 'object' && Array.isArray(idx.pages)) return 'ready'
    return 'unsupported'
}
// запросить индекс языка lang (один раз на базу · версию бэка · язык; идущий запрос не дублируется). onChange() — когда состояние
// сменится (индекс пришёл / метода нет / ошибка). Возвращает состояние: ready | loading | unsupported | error | '' (запрос не ушёл)
export function docsSearch_ensure(store, WIDGET, lang, onChange) {
    const key = cacheKey(store, lang)
    let e = cache[key]
    // IE 2026 09 28 / ODOO-342342 (ревью п.6): бэк сам объявил docs_index — «метода нет» у него не бывает: мемо «unsupported» (ключа и базы)
    // не действует, ответ без индекса (сессия истекла — {isAuthenticated: false}, сбой) — ошибка с повтором через RETRY_MS. Иначе после
    // выхода и входа без перезагрузки страницы «Found in text» не вернулся бы до F5
    const declared = docsNav_backendDeclared(WIDGET, 'docs_index')
    if (e && (e.state === 'ready' || (e.state === 'unsupported' && !declared))) return e.state
    if (e && e.state === 'loading') { if (onChange) e.waiters.add(onChange); return 'loading' }
    // IE 2026 09 28 / ODOO-342342: бэк этой базы уже сказал «метода нет» — другой язык / версия не спрашивает до перезагрузки страницы
    if (!declared && unsupportedDb.has(dbKey(store))) { stats.unsupportedSkipped++; return 'unsupported' }
    if (e && e.state === 'error' && now() - e.at < RETRY_MS) return 'error'
    // IE 2026 09 28 / ODOO-342342: бэк не объявил docs_index (старый бэк: метода нет, каждый вызов — «!!ERROR (method=docs_index, …)» в его логе) —
    // не спрашиваем вовсе; меню читалки без «Found in text», как при ответе «метода нет»
    if (!docsSearch_backendHasIndex(store, WIDGET)) { stats.noCapability++; return 'unsupported' }
    // IE 2026 09 29 / ODOO-342781 (ревью ie-dm7 F1): роль «только чтение» и политика бэка docs_index не разрешает — индекс фон читалки, без действия пользователя: не шлём, без
    // тоста; состояние не запоминаем (ни записи кэша, ни «unsupportedDb»): политика может смениться (другая база — ответ get_startup), тогда следующий вызов спросит. Без роли
    // readonly_allows всегда true — как было; стор без этого метода (тесты) — тоже
    if (store && typeof store.readonly_allows === 'function' && !store.readonly_allows('executeWidgetMethod', 'docs_index')) { stats.roSkipped++; return 'unsupported' }
    const vueObj = WIDGET?.vueObj
    if (!store || typeof store.executeStoreMethod !== 'function' || !vueObj || WIDGET.close) return ''
    e = cache[key] = { state: 'loading', index: null, at: now(), ms: 0, bytes: 0, waiters: new Set(onChange ? [onChange] : []) }
    stats.indexRequests++
    const t0 = now()
    let settled = false
    const settle = (answer) => {
        if (settled) return
        settled = true
        let v = docsSearch_verdict(answer)   // IE 2026 09 28 / ODOO-342342 (ревью п.6): let — вердикт уточняется строкой ниже
        if (v === 'unsupported' && declared) { v = 'error'; stats.declaredEmpty++ }   // IE 2026 09 28 / ODOO-342342 (ревью п.6)
        e.state = v
        e.at = now()
        e.ms = round(e.at - t0)
        if (v === 'ready') {
            e.index = answer.docs_index
            try { e.bytes = JSON.stringify(e.index).length } catch (x) { e.bytes = 0 }
            stats.indexReady++
            stats.indexMs = round(stats.indexMs + e.ms)
            stats.indexBytes += e.bytes
        } else if (v === 'unsupported') { stats.unsupported++; unsupportedDb.add(dbKey(store)) }   // IE 2026 09 28 / ODOO-342342
        else stats.errors++
        const ws = [...e.waiters]
        e.waiters.clear()
        for (const fn of ws) { try { fn(v) } catch (x) { console.warn('docsSearch: onChange', x) } }
    }
    try {
        store.executeStoreMethod(vueObj, {
            command: 'executeWidgetMethod',
            method: 'docs_index',
            params: { lang },
            // запись читалки без текста документа — индекс от неё не зависит; чтение: не отменяет идущее листание (open_doc) и не ставит «загрузку»
            record: { id: WIDGET.record?.id, segment: WIDGET.record?.segment, doc: { doc_link: WIDGET.record?.doc?.doc_link || '' } },
            no_del_last_backend_action: true,
            // ДО применения ответа (идёт при любом удачном ответе, в том числе устаревшем по номеру действия); HTTP-ошибка — _onResponse(null)
            _response_callback: (answer) => settle(answer),
            _onResponse: (answer) => settle(answer),
        })
    } catch (x) {
        console.warn('docsSearch: docs_index request', x)
        settle(null)
    }
    return e.state
}
// IE 2026 09 28 / ODOO-342342: бэк читалки объявил docs_index — WIDGET.docs_capabilities (ответ widget_open читалки) содержит 'docs_index';
// выключатель fe.help.docsIndexCapability = false — признак не требуется (спрашивать, как до правки). Общее правило — utils/docsNav.js
export function docsSearch_backendHasIndex(store, WIDGET) {
    return docsNav_backendHas(store, WIDGET, 'docs_index')
}

// ---------------------------------------------------------------- поиск по тексту

// фрагмент текста вокруг первого совпадения: { text, ranges } (диапазоны — в координатах фрагмента), «…» по обрезанным краям
export function docsSearch_snippet(text, ranges, { before = SNIPPET_BEFORE, after = SNIPPET_AFTER } = {}) {
    const src = String(text ?? '').replace(/\n/g, ' ')   // та же длина — диапазоны не сдвигаются
    const rs = (ranges || []).filter(r => r && r.end > r.start).slice().sort((a, b) => a.start - b.start)
    const first = rs[0] || { start: 0, end: 0 }
    let from = Math.max(0, first.start - before), to = Math.min(src.length, first.end + after)
    if (from > 0) { const sp = src.lastIndexOf(' ', first.start - 1); from = sp >= from - 15 && sp >= 0 && sp < first.start ? sp + 1 : from }
    if (to < src.length) { const sp = src.indexOf(' ', to); to = sp >= 0 && sp - to < 15 ? sp : to }
    const head = from > 0 ? '… ' : '', tail = to < src.length ? ' …' : ''
    const shift = head.length - from
    const out = rs.filter(r => r.start >= from && r.end <= to).map(r => ({ ...r, start: r.start + shift, end: r.end + shift }))
    return { text: head + src.slice(from, to) + tail, ranges: out }
}

// совпадения запросов queries (каждый обязан найтись — как чипсы MenuPanel) в разделах индекса: { pages: [{ link, title, score, sections:
// [{ anchor, heading, level, headingHtml, snippetHtml }], more }], total, found, ms, tier, conv }. Лестница searchLadder — по строкам
// [заголовок раздела, текст раздела]; разделы — в порядке документа, страницы — сначала с совпадением в заголовке раздела, дальше порядок индекса
export function docsSearch_find(index, queries, { maxTier = TEXT_MAX_TIER, maxPages = MAX_PAGES, maxSections = MAX_SECTIONS, extra = true } = {}) {   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): extra — последняя ступень лестницы (итог tier ≥ 7)
    const t0 = now()
    const qs = (queries || []).map(q => String(q ?? '').trim()).filter(Boolean)
    const out = { pages: [], total: 0, found: false, ms: 0, tier: 0, conv: '' }
    if (!index || !Array.isArray(index.pages) || !qs.length) return out
    const rows = [], refs = []
    for (const p of index.pages) (p.sections || []).forEach((s, j) => { rows.push([String(s.heading || ''), String(s.text || '')]); refs.push([p, s, j]) })
    const ms = qs.map(q => searchLadder(rows, q, { maxTier, extra }))
    stats.searches++
    if (!rows.length || ms.some(m => !m.found)) return finish(out, t0)
    out.tier = Math.max(0, ...ms.map(m => m.tier || 0))
    out.conv = ms.map(m => m.conv).filter(Boolean).join(' ')
    const byPage = new Map()
    for (let i = 0; i < rows.length; i++) {
        const hl = [[], []]
        let ok = true
        for (const m of ms) {
            const r = m.testRow(rows[i])
            if (!r) { ok = false; break }
            hl[0].push(...(r[0] || []))
            hl[1].push(...(r[1] || []))
        }
        if (!ok) continue
        const [p, s, pos] = refs[i]
        let e = byPage.get(p.link)
        if (!e) { e = { link: p.link, title: String(p.title || ''), order: byPage.size, score: 0, sections: [], more: 0 }; byPage.set(p.link, e) }
        out.total++
        e.score = Math.max(e.score, hl[0].length ? 2 : 1)
        if (e.sections.length >= maxSections) { e.more++; if (!e.moreAnchor) { e.moreAnchor = String(s.anchor || ''); e.morePos = pos } continue }
        const sn = docsSearch_snippet(rows[i][1], hl[1])
        e.sections.push({
            anchor: String(s.anchor || ''), level: s.level | 0, heading: rows[i][0], pos,   // pos — место раздела на странице (docsSearch_localize)
            headingHtml: hl[0].length ? highlightRanges(rows[i][0], hl[0], { escape: true }) : '',
            snippetHtml: sn.text ? highlightRanges(sn.text, sn.ranges, { escape: true }) : '',
        })
    }
    out.pages = [...byPage.values()].sort((a, b) => (b.score - a.score) || (a.order - b.order)).slice(0, maxPages)
    out.found = out.pages.length > 0
    return finish(out, t0)
}
// найденное в индексе другого языка (запасной en) — якоря разделов на языке интерфейса: страница открывается в языке интерфейса, а слаги
// заголовков у языков разные. Раздел сопоставляется по месту на странице, только если разделы страниц совпадают (число и уровни — переводы
// портала повторяют структуру); иначе якорь прежний (явные {#id} у переводов общие)
export function docsSearch_localize(res, src, dst) {
    if (!res || !res.pages || !src || !dst || !Array.isArray(src.pages) || !Array.isArray(dst.pages)) return res
    const sp = new Map(src.pages.map(p => [p.link, p])), dp = new Map(dst.pages.map(p => [p.link, p]))
    const same = (a, b) => !!a && !!b && (a.sections || []).length === (b.sections || []).length && a.sections.every((x, i) => (x.level | 0) === (b.sections[i].level | 0))
    const at = (d, pos, fallback) => (pos != null && d.sections[pos]) ? String(d.sections[pos].anchor || '') : fallback
    return {
        ...res,
        pages: res.pages.map(p => {
            const a = sp.get(p.link), d = dp.get(p.link)
            if (!same(a, d)) return p
            return { ...p, sections: p.sections.map(x => ({ ...x, anchor: at(d, x.pos, x.anchor) })), moreAnchor: p.more ? at(d, p.morePos, p.moreAnchor) : p.moreAnchor }
        }),
    }
}

function finish(out, t0) {
    out.ms = round(now() - t0)
    stats.searchMs = round(stats.searchMs + out.ms)
    if (out.ms > stats.searchMaxMs) stats.searchMaxMs = out.ms
    return out
}

// ---------------------------------------------------------------- группы формы (строки MenuPanel)

const docRow = (title, link, extra = {}) => ({ titleAction: title, title, command: DOCS_CMD, id: link, _docs: { link }, ...extra })

// Contents: разделы открытого документа (### — под своим ##); path — документ без #якоря
export function docsMenu_contentsGroup(headings, path, t) {
    const rows = []
    let h2 = null
    for (const h of headings || []) {
        const row = docRow(h.text, h.anchor ? `${path}#${h.anchor}` : path, { _docs: { link: h.anchor ? `${path}#${h.anchor}` : path, anchor: h.anchor, local: true } })
        if (h.level === 3 && h2) (h2.attrs = h2.attrs || []).push(row)
        else { rows.push(row); h2 = h.level === 2 ? row : null }
    }
    return rows.length ? { titleAction: t('Contents'), _key: 'Contents', attrs: rows } : null
}

// «Все инструкции»: страницы руководства по группам оглавления (индекс бэка); заголовок группы — ссылка на оглавление. Индекса нет —
// документ руководства: одна строка на оглавление; иначе группы нет
export function docsMenu_guidesGroup(index, WIDGET, t) {
    const titles = new Map(((index && index.pages) || []).map(p => [p.link, String(p.title || '')]))
    if (index && Array.isArray(index.groups) && index.groups.length) {
        const head = index.contents ? docRow(index.contents_title || t('All guides'), index.contents) : { titleAction: t('All guides') }
        const attrs = index.groups.map(g => ({ titleAction: String(g.title || '') || t('Other pages'), attrs: (g.pages || []).filter(l => titles.has(l)).map(l => docRow(titles.get(l) || l, l)) }))
            .filter(g => g.attrs.length)
        return attrs.length ? { ...head, _key: 'All guides', attrs } : null
    }
    const cur = WIDGET?.record?.doc?.doc_link || ''
    const link = docsNav_contentsLink(WIDGET) || (docsNav_inGuide(cur) ? CONTENTS_LINK : '')
    if (!link) return null
    return { titleAction: t('All guides'), _key: 'All guides', attrs: [docRow(t('Open all guides'), docsNav_norm(link))] }
}

// Found in text: найденное docsSearch_find — страница (ссылка на её начало; совпадение во вступлении — фрагмент у строки страницы) и её разделы
export function docsMenu_textGroup(res, t, { note = '' } = {}) {
    if (!res || !res.pages || !res.pages.length) return null
    const attrs = res.pages.map(p => {
        const intro = p.sections.find(s => !s.anchor)
        const secs = p.sections.filter(s => s.anchor)
        const row = docRow(p.title || p.link, p.link, intro ? { _snippet: intro.snippetHtml } : {})
        const kids = secs.map(s => docRow(s.heading || p.title, `${p.link}#${s.anchor}`, { _html: s.headingHtml, _snippet: s.snippetHtml }))
        if (p.more) kids.push(docRow(t('{n} more on this page', { n: p.more }), p.moreAnchor ? `${p.link}#${p.moreAnchor}` : p.link))
        if (kids.length) row.attrs = kids
        return row
    })
    return { titleAction: t('Found in text'), _key: 'Found in text', _note: note, attrs }
}

// строки Command panel без «Contents» (она открывает эту же форму)
export function docsMenu_commandGroups(actionMenu) {
    const out = []
    for (const g of actionMenu || []) {
        const attrs = (g.attrs || []).filter(a => a && a.method !== 'onDocsContents')
        if (attrs.length) out.push({ ...g, attrs })
    }
    return out
}

// пункт относится к документу path (без #якоря) — текущая страница в «Все инструкции» / Found in text
export function docsMenu_isPage(raw, path) {
    const l = raw && raw._docs && raw._docs.link
    return !!l && !raw._docs.anchor && !String(l).includes('#') && docsNav_path(l) === docsNav_path(path)
}

// ---------------------------------------------------------------- замеры

export function docsSearch_count(key) { if (key in stats) stats[key]++ }
export function docsSearch_noteFallback() { stats.fallbackEn++ }
export function docsSearch_stats() {
    const idx = {}
    for (const [k, e] of Object.entries(cache)) idx[k] = { state: e.state, ms: e.ms, bytes: e.bytes, pages: e.index ? e.index.pages.length : 0 }
    return { ...stats, index: idx }
}
export function docsSearch_console() {
    if (typeof window === 'undefined' || !window.helpDocs) return
    window.helpDocs.search = () => docsSearch_stats()
}
// для тестов: сброс состояния модуля
export function docsSearch__resetForTests() {
    for (const k of Object.keys(cache)) delete cache[k]
    for (const k of Object.keys(stats)) stats[k] = 0
    unsupportedDb.clear()   // IE 2026 09 28 / ODOO-342342: «метода нет» по базам — тоже состояние модуля (иначе утекает между тестами)
}
